import React, { useEffect, useContext,useState,useRef } from 'react';
import { store } from '../AddOrEdit';
import { useParams } from 'react-router-dom';
import Categories from './Categories';
import ListRules from './ListRules';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import Button from "@material-ui/core/Button"
import UsersDialog from '../../../../../../../components/Dialog/UsersDialog/UsersDialog';

const useStyles = makeStyles((theme) => ({
  title: {
    width: '100%',
    marginLeft: theme.spacing(2),
  },
}));

const Rules = () => {
  const classes = useStyles();
  const {
    state,
    dispatch,
    showMessage,
    showError,
    loadCategories,
    transferRules,
  } = useContext(store);
  const { rules, categories, category } = state;
  const { id } = useParams();
  const [operatorsDialog,setOperatorsDialog] = useState(false);
  const firstRun = useRef(true);

  const handleShowOperatorDialog = ()=>{
    setOperatorsDialog(true);
  }
  const handleCloseOperatorDialog = (users)=>{
    if(users){
      const [user] = users;
      transferRules(id,user._id);
    }
    setOperatorsDialog(false);
  }

  useEffect(() => {
    if(firstRun.current){firstRun.current=false; return;}
    loadCategories();
  }, [category]);

  return (
    <div style={{ display: 'flex', flexFlow: 'column wrap', alignItems:'flex-start' }}>
      <UsersDialog role={['admin']} onChange={handleCloseOperatorDialog} open={operatorsDialog} single closeDialog={handleCloseOperatorDialog} />
      <Typography variant="h2" component="h2" className={classes.title}>
        تعیین دسترسی‌های کارشناس حمل:
      </Typography>
      {!category && <Categories />}
      {category && <ListRules />}
      {!category && <Button onClick={handleShowOperatorDialog} variant='outlined' style={{marginRight:20}}>انتقال دسترسی از کارشناس حمل دیگر</Button>}
    </div>
  );
};

export default React.memo(Rules);
